<template>
  <div class="totals-row">
    <h6 :class="{'cart-total': $props.cartTotal}">
      {{ $props.totalName }}
      <span class="total-price-note">{{ $props.note }}</span>
    </h6>
    <div class="total-price-wrapper">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'checkout-cart-totals-row',
  props: {
    totalName: String,
    cartTotal: Boolean,
    note: String
  }
}
</script>

<style scoped lang="scss">
.totals-row {
  display: flex;
  align-items: center;
  padding: 2rem 2.4rem;
  background-color: $white;
  margin-bottom: 4px;

  @media (map_get($breakpoints, sm)) {
    padding: 2.8rem 2.4rem;
  }

  h6 {
    flex: 1 1 auto;
    font-size: 1.4rem;
    font-weight: 600;
    margin: 0;
    padding-right: 1.6rem;

    @media (map_get($breakpoints, sm)) {
      font-size: 1.6rem;
    }

    &.cart-total {
      font-size: 1.6rem;
      color: $primary;
      text-transform: uppercase;

      @media (map_get($breakpoints, sm)) {
        font-size: 1.8rem;
      }
    }

    .total-price-note {
      display: block;
      font-weight: 400;
    }
  }

  .total-price-wrapper {
    flex: 0 0 33%;
    text-align: right;

    @media (map_get($breakpoints, sm)) {
      flex-basis: calc(16% + 2.4rem);
      min-width: calc(16% + 2.4rem);
      text-align: left;
    }
  }
}
</style>
